export default __webpack_public_path__ + "static/embla-logo-light-theme-998e60170b41826ce3f4599ac9a68335.svg";